module.exports = __webpack_public_path__ + "img/core4.8bb7342f.png";